import { z } from 'zod';

export const loginFormSchema = z.object({
  email: z.string({ required_error: 'Email é obrigatório' }).email('Email inválido'),
  password: z.string({ required_error: 'Senha é obrigatória' }).min(3, 'Senha deve ter no mínimo 3 caracteres'),
});

export type LoginFormValues = z.infer<typeof loginFormSchema>;
